(() => {
  if (window.__coverageMapPageLoaded) {
    if (typeof window.__coverageMapPageScan === 'function') {
      window.__coverageMapPageScan();
    }
    return;
  }

  window.__coverageMapPageLoaded = true;

  const WORLD_URL = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';
  const D3_GEO_URL = 'https://cdn.jsdelivr.net/npm/d3-geo@3/+esm';
  const TOPOJSON_URL = 'https://cdn.jsdelivr.net/npm/topojson-client@3/+esm';
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const LAST_COUNTRY_STORAGE_KEY = 'travelFiCoverageLastCountry';
  const REGIONAL_PLANS_COLLECTION_HANDLE = 'multi-regional-esim-plans';
  const regionalPlanMatchers = {
    'Europe': /europe/i,
    'Asia': /asia|thailand malaysia singapore|south korea china japan|china \(mainland/i,
    'North America': /north america/i,
    'South America': /south america/i,
    'Central America & Caribbean': /global/i,
    'Oceania': /australia & new zealand/i,
    'Africa': /africa/i,
    'Middle East': /middle east|gulf/i,
    'Global': /global/i
  };

  const ISO = ['AD','AE','AF','AG','AI','AL','AM','AO','AR','AS','AT','AU','AW','AZ','BA','BB','BD','BE','BF','BG','BH','BI','BJ','BN','BO','BR','BS','BT','BW','BY','BZ','CA','CD','CF','CG','CH','CI','CL','CM','CN','CO','CR','CU','CV','CY','CZ','DE','DJ','DK','DM','DO','DZ','EC','EE','EG','EH','ER','ES','ET','FI','FJ','FK','FM','FO','FR','GA','GB','GD','GE','GF','GG','GH','GI','GL','GM','GN','GP','GQ','GR','GT','GU','GW','GY','HK','HN','HR','HT','HU','ID','IE','IL','IM','IN','IQ','IR','IS','IT','JE','JM','JO','JP','KE','KG','KH','KI','KM','KN','KP','KR','KW','KY','KZ','LA','LB','LC','LI','LK','LR','LS','LT','LU','LV','LY','MA','MC','MD','ME','MG','MH','MK','ML','MM','MN','MO','MP','MQ','MR','MS','MT','MU','MV','MW','MX','MY','MZ','NA','NC','NE','NG','NI','NL','NO','NP','NR','NZ','OM','PA','PE','PF','PG','PH','PK','PL','PM','PR','PS','PT','PW','PY','QA','RE','RO','RS','RU','RW','SA','SB','SC','SD','SE','SG','SI','SK','SL','SM','SN','SO','SR','SS','ST','SV','SX','SY','SZ','TD','TG','TH','TJ','TL','TM','TN','TO','TR','TT','TV','TW','TZ','UA','UG','US','UY','UZ','VA','VC','VE','VG','VI','VN','VU','WS','YE','ZA','ZM','ZW'];

  const aliases = {
    'bolivia': 'BO', 'brunei': 'BN', 'czech republic': 'CZ', 'czechia': 'CZ', 'ivory coast': 'CI',
    'cote d ivoire': 'CI', 'congo': 'CG', 'republic of the congo': 'CG', 'democratic republic of the congo': 'CD',
    'dr congo': 'CD', 'drc': 'CD', 'eswatini': 'SZ', 'swaziland': 'SZ', 'iran': 'IR', 'laos': 'LA',
    'moldova': 'MD', 'north macedonia': 'MK', 'macedonia': 'MK', 'palestine': 'PS', 'russia': 'RU',
    'south korea': 'KR', 'north korea': 'KP', 'syria': 'SY', 'taiwan': 'TW', 'tanzania': 'TZ', 'turkey': 'TR',
    'turkiye': 'TR', 'united kingdom': 'GB', 'great britain': 'GB', 'uk': 'GB', 'united states': 'US',
    'united states of america': 'US', 'usa': 'US', 'vatican city': 'VA', 'vietnam': 'VN'
  };

  const worldAliases = {
    'united states of america': 'US', 'dem rep congo': 'CD', 'dem rep korea': 'KP', 'central african rep': 'CF',
    'eq guinea': 'GQ', 'w sahara': 'EH', 'dominican rep': 'DO', 'falkland is': 'FK', 'fr s antarctic lands': 'TF',
    'bosnia and herz': 'BA', 's sudan': 'SS', 'solomon is': 'SB', 'timor leste': 'TL', 'n cyprus': 'CY',
    'somaliland': 'SO', 'kosovo': 'XK', 'czechia': 'CZ', 'cote d ivoire': 'CI', 'ivory coast': 'CI',
    'brunei': 'BN', 'laos': 'LA', 'vietnam': 'VN', 'russia': 'RU', 'iran': 'IR', 'syria': 'SY', 'moldova': 'MD',
    'south korea': 'KR', 'north korea': 'KP', 'tanzania': 'TZ', 'bolivia': 'BO', 'venezuela': 'VE',
    'swaziland': 'SZ', 'eswatini': 'SZ', 'the bahamas': 'BS', 'bahamas': 'BS'
  };

  let nameToCode = null;

  const normalize = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim();

  const buildNameToCode = () => {
    if (nameToCode) return nameToCode;
    nameToCode = { ...aliases, ...worldAliases };

    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      const regionDisplay = new Intl.DisplayNames(['en'], { type: 'region' });
      ISO.forEach(code => {
        try {
          const name = regionDisplay.of(code);
          if (name && name !== code) {
            nameToCode[normalize(name)] = code;
          }
        } catch (error) {
          // noop
        }
      });
    }

    return nameToCode;
  };

  const resolveCode = (rawName, explicitIso2) => {
    if (explicitIso2 && /^[A-Za-z]{2}$/.test(explicitIso2)) {
      const upper = explicitIso2.toUpperCase();
      if (ISO.includes(upper)) return upper;
    }

    const trimmed = String(rawName || '').trim();
    if (/^[A-Za-z]{2}$/.test(trimmed)) {
      const upper = trimmed.toUpperCase();
      if (ISO.includes(upper)) return upper;
    }

    return buildNameToCode()[normalize(trimmed)] || null;
  };

  const featureCode = feature => {
    const name = feature && feature.properties && feature.properties.name;
    if (!name) return null;
    return buildNameToCode()[normalize(name)] || null;
  };

  const productCache = new Map();
  const regionalPlansCache = new Map();

  const formatPrice = (amount, currencyCode) => {
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currencyCode || 'USD'
      }).format(amount / 100);
    } catch (error) {
      return `$${(amount / 100).toFixed(2)}`;
    }
  };

  const fetchProduct = (handle, productUrlBase, currencyCode) => {
    if (!productCache.has(handle)) {
      const request = fetch(`${productUrlBase}${encodeURIComponent(handle)}.js`)
        .then(response => {
          if (!response.ok) throw new Error(`Unable to load product ${handle}`);
          return response.json();
        })
        .then(product => {
          const variantPrices = Array.isArray(product.variants)
            ? product.variants.map(variant => Number(variant.price)).filter(Number.isFinite)
            : [];
          const lowestPrice = variantPrices.length ? Math.min(...variantPrices) : Number(product.price);
          return {
            title: product.title || handle,
            url: product.url || `${productUrlBase}${handle}`,
            price: Number.isFinite(lowestPrice) ? `From ${formatPrice(lowestPrice, currencyCode)}` : 'View plans',
            image: product.featured_image || product.images?.[0] || ''
          };
        })
        .catch(() => null);
      productCache.set(handle, request);
    }
    return productCache.get(handle);
  };

  const loadCountryPlans = async (country, productUrlBase, currencyCode) => {
    let countryPlans = [];
    if (Array.isArray(country.plans) && country.plans.length) {
      countryPlans = country.plans;
    } else if (Array.isArray(country.product_handles) && country.product_handles.length) {
      const products = await Promise.all(
        country.product_handles.map(handle => fetchProduct(handle, productUrlBase, currencyCode))
      );
      countryPlans = products.filter(Boolean);
    }

    const regionalPlans = await loadRegionalPlans(country.region, productUrlBase, currencyCode);
    return [
      ...countryPlans.slice(0, 2).map(plan => ({ ...plan, kind: 'country' })),
      ...regionalPlans.map(plan => ({ ...plan, kind: 'regional' }))
    ];
  };

  const loadRegionalPlans = async (region, productUrlBase, currencyCode) => {
    const matcher = regionalPlanMatchers[region];
    if (!matcher) return [];

    const cacheKey = `${region}:${productUrlBase}:${currencyCode}`;
    if (!regionalPlansCache.has(cacheKey)) {
      const collectionUrl = productUrlBase.replace(/products\/?$/, `collections/${REGIONAL_PLANS_COLLECTION_HANDLE}/products.json?limit=100`);
      const request = fetch(collectionUrl)
        .then(response => {
          if (!response.ok) throw new Error(`Unable to load regional plans for ${region}`);
          return response.json();
        })
        .then(({ products }) => (Array.isArray(products) ? products : [])
          .filter(product => matcher.test(product.title || ''))
          .slice(0, 2)
          .map(product => {
            const price = Number(product.variants?.map(variant => Number(variant.price)).filter(Number.isFinite).sort((left, right) => left - right)[0]);
            return {
              title: product.title || 'Regional eSIM',
              url: product.url || `${productUrlBase}${product.handle}`,
              price: Number.isFinite(price) ? `From ${new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currencyCode || 'USD' }).format(price)}` : 'View plans',
              image: product.featured_image?.src || product.images?.[0]?.src || product.images?.[0] || ''
            };
          }))
        .catch(() => []);
      regionalPlansCache.set(cacheKey, request);
    }
    return regionalPlansCache.get(cacheKey);
  };

  const hydrateCountryFlag = async (flag, productUrlBase, currencyCode) => {
    if (!flag || flag.dataset.loaded === 'true') return;
    flag.dataset.loaded = 'true';

    const product = await fetchProduct(flag.dataset.productHandle, productUrlBase, currencyCode);
    if (!product?.image) {
      flag.remove();
      return;
    }

    const image = document.createElement('img');
    image.className = 'coverage-by-region__country-flag-image';
    image.src = product.image;
    image.alt = '';
    image.loading = 'lazy';
    flag.append(image);
  };

  const setupCountryFlagLoading = (productUrlBase, currencyCode) => {
    const flags = document.querySelectorAll('[data-coverage-country-flag]:not([data-observed])');
    if (!flags.length) return;

    const load = flag => hydrateCountryFlag(flag, productUrlBase, currencyCode);
    if (!('IntersectionObserver' in window)) {
      flags.forEach(load);
      return;
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    }, { rootMargin: '180px 0px' });

    flags.forEach(flag => {
      flag.dataset.observed = 'true';
      observer.observe(flag);
    });
  };

  const normalizeCountry = country => {
    const networks = Array.isArray(country.networks)
      ? country.networks.map(network => {
        if (typeof network === 'string') return network;
        const generations = Array.isArray(network.generations) ? network.generations.join('/') : '';
        return [network.operator, generations ? `(${generations})` : ''].filter(Boolean).join(' ');
      })
      : [];
    return {
      ...country,
      status: country.status || country.coverage_status,
      networks
    };
  };

  const renderPlans = (container, country) => {
    container.innerHTML = '';

    if (!country || !Array.isArray(country.plans) || !country.plans.length) {
      const empty = document.createElement('p');
      empty.className = 'coverage-map-module__empty';
      empty.textContent = container.dataset.emptyLabel || 'No plans linked yet';
      container.append(empty);
      return;
    }

    country.plans.forEach((plan, index) => {
      if (plan.kind === 'regional' && (index === 0 || country.plans[index - 1]?.kind !== 'regional')) {
        const regionalLabel = document.createElement('p');
        regionalLabel.className = 'coverage-map-module__plan-group-label';
        regionalLabel.textContent = 'Regional plans';
        container.append(regionalLabel);
      }

      const card = document.createElement('a');
      card.className = `coverage-map-module__plan${plan.kind === 'regional' ? ' is-regional' : ''}`;
      card.href = plan.url || '#';

      const isUnlimited = /unlimited|infinity/i.test(plan.title || '');

      const image = plan.image ? document.createElement('img') : document.createElement('span');
      image.className = 'coverage-map-module__plan-image';
      if (plan.image) {
        image.loading = 'lazy';
        image.alt = plan.title || 'TravelFi eSIM plan';
        image.src = plan.image;
      }

      const title = document.createElement('p');
      title.className = 'coverage-map-module__plan-title';
      title.textContent = plan.title || 'TravelFi eSIM';

      const planIcon = document.createElement('span');
      planIcon.className = 'coverage-map-module__plan-icon';
      planIcon.setAttribute('aria-label', isUnlimited ? 'Unlimited plan' : 'Fixed data plan');
      planIcon.innerHTML = isUnlimited
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 8c2.5 0 4.5 3 5 4 .5-1 2.5-4 5-4 2.8 0 4 2.1 4 4s-1.2 4-4 4c-2.5 0-4.5-3-5-4-.5 1-2.5 4-5 4-2.8 0-4-2.1-4-4s1.2-4 4-4Z"></path></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="4" width="14" height="16" rx="2"></rect><path d="M8 9h8M8 13h5"></path></svg>';

      const price = document.createElement('span');
      price.className = 'coverage-map-module__plan-price';
      price.textContent = plan.price || '';

      const details = document.createElement('span');
      details.className = 'coverage-map-module__plan-details';
      details.textContent = 'View details';

      card.append(image, title, planIcon, price, details);
      container.append(card);
    });
  };

  const renderPopularDestinations = (container, countries, productUrlBase, currencyCode, selectCountry) => {
    if (!container) return;
    container.innerHTML = '';

    const preferredCodes = ['IT', 'FR', 'JP', 'US', 'CA', 'AU'];
    const popularCountries = preferredCodes
      .map(code => countries.get(code))
      .filter(Boolean);
    const destinations = (popularCountries.length ? popularCountries : Array.from(countries.values())).slice(0, 6);

    destinations.forEach(country => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'coverage-map-module__popular-country';
      button.textContent = country.country;
      button.addEventListener('click', () => selectCountry(country.code));
      container.append(button);

      const handle = country.product_handles?.[0];
      if (!handle) return;
      fetchProduct(handle, productUrlBase, currencyCode).then(product => {
        if (!product?.image) return;
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        button.prepend(image);
      });
    });
  };

  const renderNetworks = (container, country, fallback) => {
    container.innerHTML = '';
    const items = country && Array.isArray(country.networks)
      ? country.networks.map(item => String(item).trim()).filter(Boolean)
      : [];

    if (!items.length) {
      const node = document.createElement('li');
      node.textContent = fallback;
      container.append(node);
      return;
    }

    items.forEach(network => {
      const node = document.createElement('li');
      node.textContent = network;
      container.append(node);
    });
  };

  const setupInteractions = (root, viewport, content, coveredCount) => {
    const baseZoom = coveredCount > 1 ? 1.65 : 1;
    const state = { k: baseZoom, x: 0, y: 0 };

    const apply = () => {
      content.style.transform = `translate(${state.x}px, ${state.y}px) scale(${state.k})`;
    };

    const clampZoom = value => Math.min(12, Math.max(0.5, value));

    const setZoom = value => {
      state.k = clampZoom(Math.round(value * 100) / 100);
      if (state.k === baseZoom) {
        state.x = 0;
        state.y = 0;
      }
      apply();
    };

    const focusOn = element => {
      if (!element) return;
      const box = element.getBBox();
      const svg = root.querySelector('[data-map-svg]');
      if (!svg || !box.width || !box.height) return;

      const svgBox = svg.getBoundingClientRect();
      const targetZoom = clampZoom(Math.max(4, Math.min(9, Math.min(600 / box.width, 320 / box.height))));
      const centerX = box.x + box.width / 2;
      const centerY = box.y + box.height / 2;
      const scaleX = svgBox.width / 1000;
      const scaleY = svgBox.height / 560;

      state.k = targetZoom;
      state.x = (500 - centerX) * scaleX * targetZoom;
      state.y = (280 - centerY) * scaleY * targetZoom;
      apply();
    };

    root.querySelector('[data-zoom-in]')?.addEventListener('click', () => setZoom(state.k + 0.8));
    root.querySelector('[data-zoom-out]')?.addEventListener('click', () => setZoom(state.k - 0.5));
    root.querySelector('[data-zoom-reset]')?.addEventListener('click', () => setZoom(baseZoom));

    let dragging = false;
    let startX = 0;
    let startY = 0;
    let originX = 0;
    let originY = 0;

    viewport.addEventListener('pointerdown', event => {
      if (event.target.closest('button, .coverage-map-module__country.is-covered')) return;
      dragging = true;
      startX = event.clientX;
      startY = event.clientY;
      originX = state.x;
      originY = state.y;
      viewport.setPointerCapture(event.pointerId);
      viewport.style.cursor = 'grabbing';
    });

    viewport.addEventListener('pointermove', event => {
      if (!dragging) return;
      state.x = originX + (event.clientX - startX);
      state.y = originY + (event.clientY - startY);
      apply();
    });

    const stopDrag = () => {
      dragging = false;
      viewport.style.cursor = '';
    };

    viewport.addEventListener('pointerup', stopDrag);
    viewport.addEventListener('pointercancel', stopDrag);

    viewport.addEventListener('wheel', event => {
      event.preventDefault();
      setZoom(state.k + (event.deltaY < 0 ? 0.6 : -0.45));
    }, { passive: false });

    apply();

    return { focusOn };
  };

  const init = async root => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const dataNode = root.querySelector('[data-coverage-countries]');
    if (!dataNode) return;

    let countries = [];
    try {
      countries = JSON.parse(dataNode.textContent || '[]');
    } catch (error) {
      console.warn('Coverage map data JSON is invalid', error);
      return;
    }

    if (!Array.isArray(countries) || !countries.length) return;

    const countryMap = new Map();
    const productUrlBase = root.dataset.productUrlBase || '/products/';
    const currencyCode = root.dataset.currencyCode || 'USD';
    setupCountryFlagLoading(productUrlBase, currencyCode);
    countries.forEach(country => {
      if (!country || !country.country) return;
      const code = resolveCode(country.country, country.iso2);
      if (!code) return;
      const normalizedCountry = normalizeCountry(country);
      normalizedCountry.code = code;
      countryMap.set(code, normalizedCountry);
    });

    const viewport = root.querySelector('[data-map-viewport]');
    const svg = root.querySelector('[data-map-svg]');
    const content = root.querySelector('[data-map-content]');
    const land = root.querySelector('[data-map-land]');
    const tooltip = root.querySelector('[data-map-tooltip]');
    const panelName = root.querySelector('[data-country-name]');
    const panelStatus = root.querySelector('[data-country-status]');
    const panelNetworks = root.querySelector('[data-country-networks]');
    const panelPlans = root.querySelector('[data-country-plans]');
    const searchInput = root.querySelector('[data-coverage-search]');
    const panelDefault = root.querySelector('[data-panel-default]');
    const panelDetail = root.querySelector('[data-panel-detail]');
    const popularDestinations = root.querySelector('[data-popular-destinations]');

    if (!viewport || !svg || !content || !land || !panelName || !panelStatus || !panelNetworks || !panelPlans) return;

    panelPlans.dataset.emptyLabel = panelPlans.querySelector('.coverage-map-module__empty')?.textContent || 'No plans linked yet';
    const emptyNetworks = panelNetworks.textContent.trim() || 'No networks listed yet';

    let selectedCountryCode = null;
    let mapControls = null;

    const selectCountryByCode = async code => {
      const selected = countryMap.get(code);
      if (!selected) return;
      selectedCountryCode = code;
      try {
        window.localStorage.setItem(LAST_COUNTRY_STORAGE_KEY, code);
      } catch (error) {
        // Browsers can disable local storage without affecting map selection.
      }
      if (panelDefault) panelDefault.hidden = true;
      if (panelDetail) panelDetail.hidden = false;

      panelName.textContent = selected.country || '';
      panelStatus.textContent = selected.status || 'Coverage available';
      renderNetworks(panelNetworks, selected, emptyNetworks);
      panelPlans.innerHTML = '<p class="coverage-map-module__empty">Loading plans...</p>';

      root.querySelectorAll('.coverage-map-module__country.is-selected').forEach(node => {
        node.classList.remove('is-selected');
      });
      const activePath = land.querySelector(`[data-country-code="${code}"]`);
      if (activePath) {
        activePath.classList.add('is-selected');
        mapControls?.focusOn(activePath);
      }

      const plans = await loadCountryPlans(selected, productUrlBase, currencyCode);
      if (selectedCountryCode !== code) return;
      renderPlans(panelPlans, { ...selected, plans });
    };

    renderPopularDestinations(popularDestinations, countryMap, productUrlBase, currencyCode, selectCountryByCode);

    const showTooltip = (event, label) => {
      if (!tooltip) return;
      const bounds = viewport.getBoundingClientRect();
      tooltip.hidden = false;
      tooltip.textContent = label;
      tooltip.style.left = `${event.clientX - bounds.left}px`;
      tooltip.style.top = `${event.clientY - bounds.top}px`;
    };

    const hideTooltip = () => {
      if (tooltip) tooltip.hidden = true;
    };

    try {
      const [geoModule, topojson, world] = await Promise.all([
        import(D3_GEO_URL),
        import(TOPOJSON_URL),
        fetch(WORLD_URL).then(response => {
          if (!response.ok) throw new Error('world data failed');
          return response.json();
        })
      ]);

      const geo = topojson.feature(world, world.objects.countries);
      const features = geo.features;
      const highlighted = features.filter(feature => countryMap.has(featureCode(feature)));

      const width = 1000;
      const height = 560;
      const padding = 24;
      const fitTarget = highlighted.length
        ? { type: 'FeatureCollection', features: highlighted }
        : geo;

      const projection = geoModule.geoMercator().fitExtent([[padding, padding], [width - padding, height - padding]], fitTarget);
      const path = geoModule.geoPath(projection);

      svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
      land.innerHTML = '';

      features.forEach(feature => {
        const shape = path(feature);
        if (!shape) return;

        const code = featureCode(feature);
        const covered = code && countryMap.has(code);
        const countryName = feature && feature.properties ? feature.properties.name : code || 'Country';

        const node = document.createElementNS(SVG_NS, 'path');
        node.setAttribute('d', shape);
        node.setAttribute('class', `coverage-map-module__country${covered ? ' is-covered' : ''}`);

        if (covered) {
          node.setAttribute('tabindex', '0');
          node.setAttribute('data-country-code', code);
          node.setAttribute('role', 'button');
          node.setAttribute('aria-label', `Show plans for ${countryName}`);

          node.addEventListener('pointerenter', event => showTooltip(event, countryName));
          node.addEventListener('pointermove', event => showTooltip(event, countryName));
          node.addEventListener('pointerleave', hideTooltip);

          node.addEventListener('click', () => selectCountryByCode(code));
          node.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              selectCountryByCode(code);
            }
          });

          node.addEventListener('focus', () => {
            const rect = node.getBoundingClientRect();
            showTooltip({ clientX: rect.left + rect.width / 2, clientY: rect.top }, countryName);
          });
          node.addEventListener('blur', hideTooltip);
        }

        land.append(node);
      });

      mapControls = setupInteractions(root, viewport, content, highlighted.length);

      try {
        const savedCountryCode = window.localStorage.getItem(LAST_COUNTRY_STORAGE_KEY);
        if (savedCountryCode && countryMap.has(savedCountryCode)) {
          selectCountryByCode(savedCountryCode);
        }
      } catch (error) {
        // Continue with the popular-destination panel when storage is unavailable.
      }

      if (searchInput) {
        searchInput.addEventListener('input', () => {
          const needle = normalize(searchInput.value);
          if (!needle) return;

          const match = Array.from(countryMap.values()).find(entry => normalize(entry.country).includes(needle));
          if (match && match.code) {
            selectCountryByCode(match.code);
          }
        });
      }
    } catch (error) {
      console.warn('Coverage map module failed to render', error);
    }
  };

  const scan = () => {
    document.querySelectorAll('[data-coverage-map-module]').forEach(node => {
      init(node);
    });
  };

  window.__coverageMapPageScan = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', event => {
    const root = event.target.querySelector('[data-coverage-map-module]');
    if (root) init(root);
  });
})();
